const ColorCircle = ({ value }) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="!mr-2 h-6 w-6 rounded-full" style={{ backgroundColor: value }}></div>
    </div>
  );
};

export default ColorCircle;
